"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SecureYourRate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="232393" id="secure-your-rate" className="bg-background w-full relative overflow-hidden" style={{
    background: "radial-gradient(ellipse at 50% 0%, hsl(222 47% 11% / 0.95) 0%, hsl(222 47% 6%) 100%)"
  }}>
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
        <div className="w-[600px] h-[600px] rounded-lg opacity-20" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='200' height='200' viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 100 Q 50 50 100 100 T 200 100' stroke='hsl(43 60% 55%)' fill='none' stroke-width='0.5'/%3E%3C/svg%3E")`,
        backgroundSize: "100px 100px"
      }} />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 py-16 flex flex-col items-center text-center">
        <div ref={ref} className={`flex flex-col items-center gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <span className="font-default text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-md bg-secondary/10 animate-pulse" style={{
          color: "var(--secondary)"
        }}>
            Last Updated: {new Date().toLocaleDateString()}
          </span>

          {}
          <h2 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight leading-tight" style={{
          color: "var(--foreground)"
        }}>
            Market Rates are Changing. Secure Yours Today.
          </h2>

          {}
          <p className="font-default text-sm sm:text-base max-w-xl leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>
            Don't let rising interest rates impact your dream home. Premier Home Loans 
            provides the stability and precision you need to lock in your financial future 
            with confidence.
          </p>

          {}
          <Button asChild size="lg" className="font-default uppercase tracking-widest text-sm font-bold px-10 py-3 rounded-md transition-all hover:scale-105 shadow-lg shadow-secondary/20" style={{
          background: "linear-gradient(to bottom right, hsl(43 60% 55%), hsl(43 60% 45%))",
          color: "hsl(222 47% 11%)"
        }}>
            <Link to="/ContactPage">Apply Now</Link>
          </Button>

          {}
          <p className="font-default text-xs" style={{
          color: "var(--muted-foreground)"
        }}>
            Questions about your eligibility?{" "}
            <Link to="/LoanOptionsPage" className="underline underline-offset-4 hover:opacity-80 transition-opacity font-semibold" style={{
            color: "var(--secondary)"
          }}>
              View Loan Options
            </Link>
          </p>
        </div>
      </div>
    </section>;
}